module.exports = __webpack_public_path__ + "img/J10571.44a3febd.png";